<template>
  <div class="appTable">
    <div class="appTable__info">
      <AppPageHeader></AppPageHeader>
    </div>
    <div class="appTable__tool">
      <div class="appTable__tool__left">
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            title="刷新"
            class="refreshBtnClass"
            @click="DoRefresh"
            :class="{'rotation_ani' : isRefreshing}"
          ></el-button>
          <el-button
            type="info"
            icon="el-icon-sunrise"
            title="回到默认"
            class="refreshBtnClass"
            @click="DoInit"
          ></el-button>
        </el-button-group>

        <!-- slot : tools -->
        <slot name="tools"></slot>
      </div>
      <div class="appTable__tool__right">
        <el-button
          type="primary"
          :icon="isFilter? 'el-icon-receiving' : 'el-icon-files'"
          :title="isFilter? '收起筛选选项' : '更多筛选选项'"
          @click="doFilter"
        ></el-button>

        <el-input v-model="searchword" placeholder="快速搜索内容">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>

    <el-collapse-transition>
      <div class="appTable_tool_filter" v-show="isFilter">
          <div class="table__filter__status">
            <p>状态：</p>
            <el-select v-model="status" placeholder="请选择" clearable>
              <el-option :value="vuezero" label="等待审核"></el-option>
              <el-option :value="vueone" label="批复成功"></el-option>              
              <el-option :value="vuetwo" label="批复失败"></el-option>
              <el-option :value="vueminus" label="全部"></el-option>
            </el-select>
          </div>
        <slot name="filter"></slot>
      </div>
    </el-collapse-transition>
    <div class="appTable__tool__fixed">
      <slot name="fixedFilter"></slot>
    </div>


    <!-- 默认的Table控件 -->
    <el-table
      :data="datas"
      stripe
      border
      class="appTable__datas"
      header-row-class-name="table-header-row"
      v-loading="loadingTable"
    >
      <template v-if="expand">
        <el-table-column type="expand">
          <template slot-scope="props">
            <slot name="expand" :props="props"></slot>
          </template>
        </el-table-column>
      </template>
      <el-table-column
          type="index"
          width="50">
      </el-table-column>

      <template v-for="item in columns">
        <template v-if="item.scope">
          <el-table-column :label="item.label" :key="item.prop" :width="item.width">
            <template slot-scope="scope">
              <slot name="columnSlotFirst" :props="scope"></slot>
            </template>
          </el-table-column>
        </template>
        <template v-if="!item.scope">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :width="item.width"
          ></el-table-column>
        </template>

        <template v-if="item.isStatus">
          <template slot-scope="scope">
            <p
              :class="getTableStatusClass(scope.row.status)"
              :key="item.prop"
            >{{scope.row.statusStr}}</p>
          </template>
        </template>
      </template>
      <el-table-column fixed="right" label="操作" class-name="column__tool">
        <template slot-scope="scope">
          <template>
            <router-link :to="{path:baseUrl + '/leaveHandle',query:{id:scope.row.id}}">
              <el-button
                type="success"
                size="mini"
                v-if="scope.row.status =='等待审核'"
                plain
                class="column__tool__buttom"
                style="margin-left:20px"
              >处理&nbsp;</el-button>
            </router-link>
          </template>
          <template>
            <router-link
              :to="{path:baseUrl + '/leaveDetail',query:{id:scope.row.id}}"
              target="_blank"
            >
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.status !='等待审核'"
                plain
                class="column__tool__buttom"
              >查看详情&nbsp;</el-button>
            </router-link>
          </template>
          <slot name="columnSlotTool" :props="scope.row.id"></slot>
        </template>
      </el-table-column>
    </el-table>

    <div class="appTable__footer">
      <div class="appTable__footer_page">
        <el-pagination
          :pager-count="5"
          class="el-pag"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="sizes,total,next, pager,prev,jumper "
          :total="total"
        ></el-pagination>
      </div>
      <div class="appTable__footer__info">
        <p>
          <i class="el-icon-info"></i>
          <slot name="table__footer__info"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseVue } from "../../mixin/index";
import { getListApi } from "@/api/core/table/table";
import { selectTableFilterStatus } from "../select";

export default {
  name: "TableContainer",
  
  mixins: [BaseVue],
  
  components: {
    selectTableFilterStatus
  },
  
  props: {
    // api 默认地址
    serverUrl: {
      type: String,
      default: ""
    },
    // 表格列配置
    columns: {
      type: Array,
      default: () => []
    },
    // 是否使用默认排序
    FilterStatusDefault: {
      type: Boolean,
      default: true
    },
    // 表单首选项是否打开
    expand: {
      type: Boolean,
      default: false
    },
    // baseurl
    baseUrl: {
      type: String,
      default: ""
    },
    // 显示审核的选项
    showReviewOption: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      isFilter: true, // 是否展开更多筛选项
      isRefreshing: false,
      loadingTable: false, // 正在加载表单
      
      datas: [], // table 数据
      
      // filter params
      searchword: "", // 搜索关键字
      status: 0,
      
      // 外部传入的筛选值
      sid: "",
      pid: "",
      partyid: "",
      unitid: "",
      ccpid: -1,
      checkid: -1,
      
      // 分页
      currentPage: 1,
      page_size: 10,
      total: 0
    };
  },
  
  methods: {
    initTable() {
      // 包裹参数
      const _this = this;
      const serverUrl = this.serverUrl;
      const tableFilterData = {
        pid: _this.pid,
        sid: _this.sid,
        unitid: _this.unitid,
        partyid: _this.partyid,
        ccpid: _this.ccpid,
        checkid: _this.checkid,
        status: _this.status,
        searchword: _this.searchword,
      };
      const start = (this.currentPage - 1) * this.page_size;
      const tablePageData = {
        start: start,
        size: _this.page_size,
      };
      
      _this.loadingTable = true;
      
      getListApi(serverUrl, tableFilterData, tablePageData)
        .then((response) => {
          const total = response.totals;
          const datas = response.datas;
          _this.datas = datas;
          _this.total = total;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          _this.loadingTable = false;
        });
    },
    
    DoInit() {
      // 恢复默认
      this.page_size = 10;
      this.currentPage = 1;
      this.searchword = "";
      this.status = 0;
      this.initTable();
    },
    
    DoRefresh() {
      // 刷新
      if (!this.isRefreshing) {
        this.isRefreshing = true;
        
        this.initTable();
        
        setTimeout(() => {
          this.isRefreshing = false;
        }, 0.7 * 1000);
      }
    },
    
    doFilter() {
      this.isFilter = !this.isFilter;
    },
    
    onToolSuccess() {
      this.initTable();
    },
    
    // 状态选择框/所属学习班改动
    onTableFilterStatusDataChanged(value) {
      this.status = value;
    },
    
    // 外部筛选框输入
    updateSid(sid) {
      this.sid = sid;
      this.initTable();
    },
    updatePid(pid) {
      this.pid = pid;
      this.initTable();
    },
    updatePartyid(partyid) {
      this.partyid = partyid;
      this.initTable();
    },
    updateUnitid(unitid) {
      this.unitid = unitid;
      this.initTable();
    },
    updateCcpid(ccpid) {
      this.ccpid = ccpid;
      this.initTable();
    },
    updateCheckid(checkid) {
      this.checkid = checkid;
      this.initTable();
    },
    
    // 分页
    handleSizeChange(p) {
      this.page_size = p;
    },
    
    handleCurrentChange(p) {
      this.currentPage = p;
    }
  },
  
  watch: {
    page_size(newVal) {
      this.initTable();
    },
    
    currentPage(newVal) {
      this.initTable();
    },
    
    status(newVal) {
      this.currentPage = 1;
      this.initTable();
    },
    
    searchword(newVal) {
      if (this.status == null) {
        this.status = -1;
      }
      this.initTable();
    }
  },
  
  mounted() {
    this.initTable();
    console.log(this.currentPage);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
